import { Component, inject, OnInit, signal } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';

import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxCalloutComponent } from '@digipay/ngx-callout';
import { DecimalPipe } from '@angular/common';
import { ConvertBankName } from '../../../../data-access/constants/banks-code-name';

@Component({
  selector: 'app-cash-out-confirm-payment',
  standalone: true,
  imports: [PipesModule, NgxButtonComponent, NgxCalloutComponent, DecimalPipe],
  templateUrl: './cash-out-confirm-payment.component.html',
  styleUrl: './cash-out-confirm-payment.component.scss',
})
export class CashOutConfirmPaymentComponent extends BaseComponent implements OnInit {
  bankName = signal('');
  private bottomSheet = inject(NgxBottomSheetService);
  data: { bankName: string; shabaNumber: string; amount: number };
  constructor() {
    super();
    this.data = this.bottomSheet.data().data;
  }
  ngOnInit(): void {
    this.bankName.set(ConvertBankName(this.data.shabaNumber));
  }

  close() {
    this.bottomSheet.closeBottomSheet();
  }
  confirm() {
    this.bottomSheet.outputData.set(true);
    this.close();
  }
}
